import { useMediaQuery } from "@mui/material";
import { makeStyles } from "tss-react/mui";

export type IStyleParams = {
  bannerUrl: string;
  smBanner: boolean;
  locale: string
};

const useStyles = makeStyles<{ params: IStyleParams }>({
  name: "MainBanner",
})((theme, { params }, classes) => ({
  bannerContainer: {
    backgroundImage: `url(${params.bannerUrl})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    height: params.smBanner ? "auto" : "100vh",
    width: params.smBanner ? "100vw" : "100%",
    aspectRatio: params.smBanner ? "8/3" : "auto",
    backgroundPosition: "center",
    position: "relative",
  },

  textContainer: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  bannerText: {
    fontSize: params.smBanner ? "40px" : "80px",
    fontFamily: params.smBanner ? "Noto Serif TC" : "Noto Serif HK",
    color: "white",
    width: "100%",
    display: "contents",
    [theme.breakpoints.down("lg")]: {
      fontSize: "65px",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "56px",
      flexDirection: "column",
      display: "flex",
      width: "50%",
    },
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      width: "75%",
    },
  },
  bannerContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "32px",
    color: "white",
    fontStyle: "italic",
    paddingTop: "20px",

    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
    },
  },
}));

export default useStyles;
